import type { AasApiAdapter, UpsertEgressConnectionInput } from "../adapter";
import { requestJson } from "../http";
import type {
	EgressBoundaryStatus,
	EgressConnection,
	EgressLogEntry,
	EgressPreset,
} from "../types";

export const egressApi: AasApiAdapter["egress"] = {
	async list(slug: string) {
		return requestJson<EgressConnection[]>(
			`/api/agents/${encodeURIComponent(slug)}/egress-connections`,
		);
	},
	async upsert(slug: string, input: UpsertEgressConnectionInput) {
		await requestJson(`/api/agents/${encodeURIComponent(slug)}/egress-connections`, {
			method: "POST",
			body: input,
		});
	},
	async delete(slug: string, name: string) {
		await requestJson<void>(
			`/api/agents/${encodeURIComponent(slug)}/egress-connections/${encodeURIComponent(name)}`,
			{ method: "DELETE" },
		);
	},
	async log(slug: string) {
		return requestJson<EgressLogEntry[]>(`/api/agents/${encodeURIComponent(slug)}/egress-log`);
	},
	async boundaryStatus() {
		return requestJson<EgressBoundaryStatus>("/api/egress-proxy/status");
	},
	async presets() {
		return requestJson<EgressPreset[]>("/api/egress-presets");
	},
};
